export default "__VITE_ASSET__DSxQ5BAm__"